define('../src/sublayouts/m2-header/m2-header',['jquery', 'slick', 'lib/utils', 'tooltipster', 'breakpoint',], function ($, slick, utils, tooltipster, breakpoint) {

    'use strict';

    var M2_HEADER = function ($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M2_HEADER.prototype.init = function () {
        var _this = this,
           $mobileMenuTrigger = _this.$component.find('.m2-header--mobile-button'),
           $mobileWrapper = $mobileMenuTrigger.closest('.m2-header--mobile'),
           colour = this.getCookie("colour"),
           $body = $('body'),
           key = 'B9C4F6CA-54D8-4EB1-9D0A-8A46762F308C',
           mobilePar = this.getUrlParameter('darkmode');

        this.mobileHeader = _this.$component.find('.m2-header--mobile');
        this.desktopHeader = _this.$component.find('.m2-header--desktop');
        
        var $submenu = this.mobileHeader.find('.m2-menu--item_submenu');

        this.lastScrollTop = 0;

        this.watchScroll();
        this.respond();


        if(mobilePar == key){
            colour = "dark";
        }

        $(window).off('scroll.m2').on('scroll.m2', function () {
            _this.watchScroll();
        });

        $(breakpoint).on('change', $.proxy(this.respond, this));
        $(window).on('orientationchange', $.proxy(this.orientationchange, this));
        $(window).on('initMobile', function () {
            _this.respond();
        });

        $('.m2-theme--main').off("click.setc").on("click.setc", function(){
            var thisCheck = $(this),
            thisCheckBox = thisCheck.closest('.m2-theme--inner').find('.m2-theme--checkbox');
            if(thisCheckBox.is(':checked')){
                $('body').removeClass('dark');
                _this.setCookie("colour", "full", 1);
            }else{
                $('body').addClass('dark')
                _this.setCookie("colour", "dark", 1);
            }
        })

        $mobileMenuTrigger.on('click',function(){
            if(!$mobileWrapper.hasClass('active')){
                _this.mobileMenuActive($mobileWrapper);
            }else{
                _this.mobileMenuClose($mobileWrapper);
            }
        })

        $submenu.on('click',function(){
            $(this).find('.m2-menu--item-link').toggleClass('m2-menu--item-link_submenu-expanded')
        })
       

        if (colour=="dark") {
			$('body').addClass('dark')
            $('.m2-theme--checkbox').prop('checked', true);
        }
        if (colour=="full") {
            $('body').removeClass('dark');
            $('.m2-theme--checkbox').prop('checked', false);
        }
        
    };

    M2_HEADER.prototype.watchScroll = function () {
        var _this = this,
            current = $(window).scrollTop();

        if (current > _this.lastScrollTop && current > 32) {
            _this.$component.find('.m2-header--main').addClass('m2-header--main_scroll');
            _this.$component.find('.m2-header--mainsub').show();
            if($(window).width() < 1025){
                _this.$component.find('.m2-header--mobile').addClass('m2-header--mobile_scroll')
            }
        } else if (current < _this.lastScrollTop) {
            if (current <= 32) {
                _this.$component.find('.m2-header--main').removeClass('m2-header--main_scroll');
                _this.$component.find('.m2-header--mainsub').hide();
                if($(window).width() < 1025){
                    _this.$component.find('.m2-header--mobile').removeClass('m2-header--mobile_scroll')
                }
            }

        };

        _this.lastScrollTop = current;
    };  

    M2_HEADER.prototype.orientationchange = function () {
        this.respond();
    };
    M2_HEADER.prototype.respond = function () {
        // trigger mobile view for 's' and 'm' breakpoints
        var _this = this;
        if (utils.breakpoint() === 's' || utils.breakpoint() === 'm') {
            // MobileMenu.init(this.$component);
            _this.mobileHeaderShow()
        } else {
            // DesktopMenu.init(this.$component);
        }
    };
    M2_HEADER.prototype.mobileHeaderShow = function () {
        var _this = this;
        _this.mobileMenuInit()
    }


    M2_HEADER.prototype.mobileMenuInit = function(){


    }

    M2_HEADER.prototype.mobileMenuActive = function(menuWrapper){
        var _this = this;
        menuWrapper.addClass('active')
        $('body').addClass( 'unscrollable' );
        //_this.$component.addClass('header-mobile')
    }
    M2_HEADER.prototype.mobileMenuClose = function(menuWrapper){
        var _this = this;
        menuWrapper.removeClass('active')
        $('body').removeClass( 'unscrollable' );
        //_this.$component.removeClass('header-mobile');
    }

    M2_HEADER.prototype.setCookie = function (cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";secure;SameSite=Strict;path=/; " + expires;
	};

	M2_HEADER.prototype.getCookie = function(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1);
			if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
		}
		return "";
	};

    M2_HEADER.prototype.getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };


    return M2_HEADER;
});

